// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusLine_statusLineContainer__rkTH7 {
  padding: 8px 12px;
  background-color: #e9ecef; /* 약간 다른 배경색 */
  border-top: 1px solid #ced4da; /* 구분선 */
  font-size: 0.875em; /* 약간 작은 폰트 */
  color: #495057;
  text-align: left;
  height: 30px; /* 고정 높이 (필요시 조절) */
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-shrink: 0; /* 컨테이너 크기가 줄어들 때 이 컴포넌트는 줄어들지 않음 */
}

.StatusLine_rowCount__xpmKF {
  margin-left: 15px; /* 간격 약간 조정 */
}

.StatusLine_loadingIndicator__K3P8- {
  margin-left: 10px;
  color: #007bff; /* 로딩 색상 */
  font-style: italic;
}

.StatusLine_hasMoreIndicator__1\\+gI0 {
  margin-left: 10px;
  color: #28a745; /* 성공/완료 색상 */
  font-style: italic;
} 
/* 다크모드 */
[data-theme="dark"] .StatusLine_statusLineContainer__rkTH7 {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text-secondary);
}

/* 행 수 — 숫자만 크게·굵게·강조색(사용자 요청 2026-10-26: 몇 행이 반영됐는지 잘 보이게) */
.StatusLine_num__qVQC7 { font-size: 1.2em; font-weight: 700; color: #1d4ed8; padding: 0 1px; }
[data-theme="dark"] .StatusLine_num__qVQC7 { color: #7cb7ff; }
`, "",{"version":3,"sources":["webpack://./src/components/StatusLine.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB,EAAE,cAAc;EACzC,6BAA6B,EAAE,QAAQ;EACvC,kBAAkB,EAAE,aAAa;EACjC,cAAc;EACd,gBAAgB;EAChB,YAAY,EAAE,mBAAmB;EACjC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,iBAAiB,EAAE,aAAa;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,UAAU;EAC1B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,aAAa;EAC7B,kBAAkB;AACpB;AACA,SAAS;AACT;EACE,qCAAqC;EACrC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA,6DAA6D;AAC7D,yBAAO,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE;AAC3E,6CAAoC,cAAc,EAAE","sourcesContent":[".statusLineContainer {\r\n  padding: 8px 12px;\r\n  background-color: #e9ecef; /* 약간 다른 배경색 */\r\n  border-top: 1px solid #ced4da; /* 구분선 */\r\n  font-size: 0.875em; /* 약간 작은 폰트 */\r\n  color: #495057;\r\n  text-align: left;\r\n  height: 30px; /* 고정 높이 (필요시 조절) */\r\n  display: flex;\r\n  align-items: center;\r\n  box-sizing: border-box;\r\n  flex-shrink: 0; /* 컨테이너 크기가 줄어들 때 이 컴포넌트는 줄어들지 않음 */\r\n}\r\n\r\n.rowCount {\r\n  margin-left: 15px; /* 간격 약간 조정 */\r\n}\r\n\r\n.loadingIndicator {\r\n  margin-left: 10px;\r\n  color: #007bff; /* 로딩 색상 */\r\n  font-style: italic;\r\n}\r\n\r\n.hasMoreIndicator {\r\n  margin-left: 10px;\r\n  color: #28a745; /* 성공/완료 색상 */\r\n  font-style: italic;\r\n} \r\n/* 다크모드 */\r\n:global([data-theme=\"dark\"]) .statusLineContainer {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\n/* 행 수 — 숫자만 크게·굵게·강조색(사용자 요청 2026-10-26: 몇 행이 반영됐는지 잘 보이게) */\r\n.num { font-size: 1.2em; font-weight: 700; color: #1d4ed8; padding: 0 1px; }\r\n:global([data-theme=\"dark\"]) .num { color: #7cb7ff; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusLineContainer": `StatusLine_statusLineContainer__rkTH7`,
	"rowCount": `StatusLine_rowCount__xpmKF`,
	"loadingIndicator": `StatusLine_loadingIndicator__K3P8-`,
	"hasMoreIndicator": `StatusLine_hasMoreIndicator__1+gI0`,
	"num": `StatusLine_num__qVQC7`
};
export default ___CSS_LOADER_EXPORT___;
